import React from 'react';
import PropTypes from 'prop-types';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { StoreComponent_StoreShowPrice as ShowPrice } from 'ggApp/modules/store';
import { UnavailableBannerContext } from '../UnavailableBannerContex';
import CheckoutItemQuantityHandler from '../ItemQuantityHandler';
import CheckoutSingleProduct from '../SingleProduct';

import {
    PriceWrapper,
    OrderTableItemMobileWrapper,
    PlanDurationNote,
    Actions,
    ActionsWrap,
    ActionsTitle,
    Remover,
} from './styled';

export default class TableItemMobile extends React.PureComponent {
    // eslint-disable-next-line react/static-property-placement
    static contextType = UnavailableBannerContext;

    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
        product: PropTypes.shape({}).isRequired,
        orderCurrencySymbol: PropTypes.string.isRequired,
        changeItemQuantity: PropTypes.func,
        removeItem: PropTypes.func,
        readOnly: PropTypes.bool,
    };

    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        changeItemQuantity: () => {},
        removeItem: () => {},
        readOnly: false,
    };

    render() {
        const {
            product,
            orderCurrencySymbol,
            changeItemQuantity,
            removeItem,
            readOnly,
        } = this.props;
        const UnavailableBanner = this.context;
        const { minimum_term_months: minimumTermMonths } = product;
        return (
            <OrderTableItemMobileWrapper>
                {!readOnly && <Remover onClick={removeItem}>×</Remover>}
                <CheckoutSingleProduct
                    product={product}
                    big={false}
                    absolute={false}
                    desktopColumn={false}
                    mobile
                />
                <PriceWrapper>
                    <ShowPrice
                        price={product && product.price}
                        orderCurrencySymbol={orderCurrencySymbol}
                    />
                    /
                    <Translator tk="MONTH_SHORT" />
                </PriceWrapper>
                {minimumTermMonths > 1 && (
                    <PlanDurationNote>
                        <Translator
                            withValues={{ duration: minimumTermMonths }}
                            tk="FOR_N_MONTHS"
                        />
                    </PlanDurationNote>
                )}
                <Actions>
                    <ActionsTitle>
                        <Translator tk="QUANTITY" />:
                    </ActionsTitle>
                    <ActionsWrap readOnly={readOnly}>
                        <CheckoutItemQuantityHandler
                            readOnly={readOnly}
                            product={product}
                            changeItemQuantity={changeItemQuantity}
                        />
                    </ActionsWrap>
                </Actions>
                {!readOnly && (
                    <UnavailableBanner variant={product.variant} lineItemId={product.id} />
                )}
            </OrderTableItemMobileWrapper>
        );
    }
}
